var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelaware(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.033,181.887l-27.113-17.254c0,0-14.792-29.583-16.274-36.484c-1.478-6.901-18.238-15.778-18.238-15.778L109.14,88.707 c0,0,5.421-11.831,7.395-12.328c0.508-0.129,1.25-1.517,2.064-3.482c2.348-5.665,5.329-16.238,5.329-16.238l-14.788-1.972 L90.271,74.921c1.772,4.21,3.609,9.05,5.481,14.357c17.864,50.628,39.021,143.885,39.021,143.885l62.616-10.357L187.033,181.887z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelaware);
export default __webpack_public_path__ + "static/media/delaware.135623d7521df77a786d679b5a1756fe.svg";
export { ForwardRef as ReactComponent };